import MondayFormFormComponent from "./monday-form-form-component";
import MondayFormFormConfig from "./monday-form-form-config";
import MondayFormFormAdvancedConfig from "./monday-form-form-advanced-config";

export default {
  MondayFormFormComponent,
  MondayFormFormConfig,
  MondayFormFormAdvancedConfig
};
